module.exports = __webpack_public_path__ + "static/logo-fc1d4a72f27910b640825d63d2ff6045.svg";